import { Flex, Image, Typography } from "antd";
import { FC } from "react";
import { ICleanMessage } from "../../../config/types";
import dayjs from "dayjs";
import { useMediaQuery } from "../../../hooks/useMediaQuery";

const MESSAGE_HEADERS: Record<string, string> = {
  clean_buy: '🛒 Что нужно купить',
  clean_keycode: '🔐 Установлен новый код',
  clean_fix: '⚙️ Что сломалось',
  clean_readings: '⏲️ Внесены показания',
  clean_files_uploaded: '📸 Загружены фото'
}

const HEADER_TEMPLATES: Record<string, string> = {
  clean_keycode: 'Установлен новый код: ',
  clean_readings: 'Горничная передала показания счетчиков.',
  clean_files_uploaded: 'Загружены фото'
}

interface MessageProps {
  message: ICleanMessage;
  ignore_screen_size?: boolean | undefined;
  show_date?: string;
}

const clearMessageFromHeader = (name: string, text: string) => {
  const template = HEADER_TEMPLATES[name]

  if (template) {
    return text.replace(template, '')
  }

  return text
}

const renderMessageBody = (message: ICleanMessage) => {
  const header = MESSAGE_HEADERS[message.name]
  return <>
    {header && <Typography.Text style={{ fontWeight: 'bold' }}>{header}</Typography.Text>}
    <Typography.Text>{clearMessageFromHeader(message.name, message.text)}</Typography.Text>
    {message.files && (
      <>
        <Image.PreviewGroup>
          {message.files
            .filter((file: any) => file.type?.startsWith("image"))
            .map((file: any) => (
              <Image width={100} preview={file.preview} src={file.url} />
            ))}
        </Image.PreviewGroup>
        {message.files
          .filter((file: any) => file.type?.startsWith("video"))
          .map((file: any) => (
            <a href={file.url} target="_blank" rel="noreferrer">
              Видео
            </a>
          ))}
      </>
    )}
  </>
}

const alignSelf = (props: MessageProps, isBigScreen: boolean) => {
  const isSelf = props.message.author === 'cleaner';

  if ((!isBigScreen || props.ignore_screen_size) && isSelf) {
    return "flex-end"
  }

  return "flex-start"
}

const width = (props: MessageProps, isBigScreen: boolean) => {
  if (!isBigScreen || props.ignore_screen_size) {
    return "70%"
  }

  return '700px'
}

const background = (props: MessageProps) => {
  const isSelf = props.message.author === 'cleaner';

  if (isSelf) {
    return "#e8fdde"
  }

  return "#fafafa"
}


export const Message: FC<MessageProps> = (props) => {
  const isBigScreen = useMediaQuery('(min-width: 1400px)');

  return (<>
    { props.show_date && <div style={{alignSelf: 'center'}}>{props.show_date}</div>}
    <Flex style={{
      maxWidth: width(props, isBigScreen),
      flexDirection: "column",
      alignItems: "flex-start",
      alignSelf: alignSelf(props, isBigScreen),
      background: background(props),
      padding: "10px",
      borderRadius: "10px",
      margin: "5px",
      whiteSpace: "break-spaces",
    }}>
      {renderMessageBody(props.message)}
      <Flex style={{ width: "100%", justifyContent: "flex-end", gap: "5px" }}>
        <Typography.Text style={{ color: "rgba(0, 0, 0, 0.25)", fontSize: "12px" }}>{dayjs(new Date(props.message.createdAt)).format("HH:mm")}</Typography.Text>
      </Flex>
    </Flex>
  </>
  );
};
